export var ScreenSizes;
(function (ScreenSizes) {
    ScreenSizes[ScreenSizes["SM_MIN_WIDTH"] = 576] = "SM_MIN_WIDTH";
    ScreenSizes[ScreenSizes["SM_MAX_WIDTH"] = 767] = "SM_MAX_WIDTH";
    ScreenSizes[ScreenSizes["MD_MIN_WIDTH"] = 768] = "MD_MIN_WIDTH";
    ScreenSizes[ScreenSizes["MD_MAX_WIDTH"] = 991] = "MD_MAX_WIDTH";
    ScreenSizes[ScreenSizes["LG_MIN_WIDTH"] = 992] = "LG_MIN_WIDTH";
    ScreenSizes[ScreenSizes["LG_MAX_WIDTH"] = 1199] = "LG_MAX_WIDTH";
    ScreenSizes[ScreenSizes["XL_MIN_WIDTH"] = 1200] = "XL_MIN_WIDTH";
    ScreenSizes[ScreenSizes["XL_MAX_WIDTH"] = 1399] = "XL_MAX_WIDTH";
    ScreenSizes[ScreenSizes["XXL_MIN_WIDTH"] = 1400] = "XXL_MIN_WIDTH";
})(ScreenSizes || (ScreenSizes = {}));
